var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { datesManager, useLanguage } from '../../locale';
import { useDeleteProfileImageApi, useGetCodeApi, useGetCustomerApi, useGetPersonApi, useRemoveMemberApi, useUploadProfileImageApi, useUserDetailApi, } from '../../hooks';
import { useCallback, useMemo, useState } from 'react';
import { FamilyRole } from '../../models';
import { useEditProfileInfoFacade, } from './useEditProfileInfo.facade';
import { useNotificationsMessage } from '../../contexts';
import { isMinor } from '../../utils';
import { LoaderType } from '../../hooks/api/utils';
import { useDispatch, useSelector } from 'react-redux';
import { GeneralActions, membersColors } from '../../redux';
var ADULT_AGE = 18;
var MONTHS_FOR_YEAR = 12;
export var useUserProfileDetailFacade = function (personId, loaderType, isPlanPreferencesEnabled) {
    var _a;
    if (loaderType === void 0) { loaderType = LoaderType.FullPage; }
    if (isPlanPreferencesEnabled === void 0) { isPlanPreferencesEnabled = false; }
    var today = datesManager();
    //** API **//
    var dispatch = useDispatch();
    var person = useGetPersonApi(personId).data;
    var customer = useGetCustomerApi().data;
    var loggedPerson = useGetPersonApi(customer === null || customer === void 0 ? void 0 : customer.personId).data;
    var invitatioPersonId = (person === null || person === void 0 ? void 0 : person.familyRole) !== FamilyRole.FAMILY_LEADER ? person === null || person === void 0 ? void 0 : person.id : undefined;
    var isMemberMinor = isMinor(person === null || person === void 0 ? void 0 : person.birthDate);
    var code = useGetCodeApi(invitatioPersonId, loggedPerson === null || loggedPerson === void 0 ? void 0 : loggedPerson.familyRole, isMemberMinor).getCode;
    var dataPerson = useEditProfileInfoFacade(person, isPlanPreferencesEnabled);
    var _b = useUploadProfileImageApi(loaderType), uploadImage = _b.mutateAsync, isUploadLoading = _b.isLoading;
    var _c = useDeleteProfileImageApi(loaderType), deleteImage = _c.mutateAsync, isDeleteLoading = _c.isLoading;
    var updatePerson = useUserDetailApi(loaderType).updatePerson;
    var removeMember = useRemoveMemberApi().mutateAsync;
    var showNotifications = useNotificationsMessage().showNotifications;
    var usersColors = useSelector(membersColors);
    var t = useLanguage()[0];
    var _d = useState(false), isVisibleModalDeleteMember = _d[0], setIsVisibleModalDeleteMember = _d[1];
    var codeValue = useMemo(function () {
        var _a;
        if (!code) {
            return;
        }
        return (_a = code === null || code === void 0 ? void 0 : code.data) === null || _a === void 0 ? void 0 : _a.code;
    }, [code]);
    var codeMessage = useMemo(function () {
        var _a;
        if (!code) {
            return;
        }
        return (_a = code === null || code === void 0 ? void 0 : code.data) === null || _a === void 0 ? void 0 : _a.message;
    }, [code]);
    var removeMemberColor = useCallback(function (membersColors) {
        dispatch(GeneralActions.setMemberColors(membersColors));
    }, [dispatch]);
    /**
     * Ritorna true solo se il membro è stato effettivamente cancellato.
     * La cancellazione può essere rifiutata dal BE (es. errorCode 18, piano
     * familiare in creazione): in quel caso l'errore è già notificato
     * dall'interceptor di PlanterHttpClient, quindi qui va solo assorbito
     * per non lasciare una promise rejection non gestita.
     */
    var onPressDeleted = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedMembersColor, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(person === null || person === void 0 ? void 0 : person.name) || !personId) {
                        return [2 /*return*/, false];
                    }
                    updatedMembersColor = __assign({}, usersColors);
                    delete updatedMembersColor[personId];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, removeMember({ personId: personId })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    return [2 /*return*/, false];
                case 4:
                    removeMemberColor(updatedMembersColor);
                    showNotifications({
                        text: t('memberProfile.deletedMemberModal.notification', {
                            name: person === null || person === void 0 ? void 0 : person.name,
                        }),
                    });
                    return [2 /*return*/, true];
            }
        });
    }); }, [
        person === null || person === void 0 ? void 0 : person.name,
        personId,
        removeMember,
        removeMemberColor,
        showNotifications,
        t,
        usersColors,
    ]);
    var onPressItemDetail = useCallback(function () {
        //TODO: implementare la logica
    }, []);
    var onPressEditPhoto = useCallback(function () {
        //TODO: implementare la logica
    }, []);
    var generateFormData = useCallback(function (image) {
        var formData = new FormData();
        var profileName = "".concat(person === null || person === void 0 ? void 0 : person.name, "_").concat(person === null || person === void 0 ? void 0 : person.id).replace(/ /g, '_');
        formData.append('filename', image, "".concat(profileName !== null && profileName !== void 0 ? profileName : new Date().getTime(), ".png"));
        return formData;
    }, [person === null || person === void 0 ? void 0 : person.id, person === null || person === void 0 ? void 0 : person.name]);
    var generateBodyDelete = useCallback(function (previousImage) {
        var imageName = previousImage === null || previousImage === void 0 ? void 0 : previousImage.split('/').pop();
        return { filename: imageName || '' };
    }, []);
    var onImageFileChange = useCallback(function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var body, uploadedImage, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!personId || !file) {
                        return [2 /*return*/];
                    }
                    if (!(person === null || person === void 0 ? void 0 : person.profileImageUrl)) return [3 /*break*/, 2];
                    return [4 /*yield*/, deleteImage(generateBodyDelete(person === null || person === void 0 ? void 0 : person.profileImageUrl))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    body = generateFormData(file);
                    return [4 /*yield*/, uploadImage(body)];
                case 3:
                    uploadedImage = _a.sent();
                    return [2 /*return*/, updatePerson({
                            id: personId,
                            profileImageUrl: uploadedImage === null || uploadedImage === void 0 ? void 0 : uploadedImage.url,
                        })];
                case 4:
                    error_2 = _a.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        deleteImage,
        generateBodyDelete,
        generateFormData,
        person === null || person === void 0 ? void 0 : person.profileImageUrl,
        personId,
        updatePerson,
        uploadImage,
    ]);
    var isFamilyMember = useMemo(function () { return (person === null || person === void 0 ? void 0 : person.familyRole) === FamilyRole.FAMILY_MEMBER; }, [person === null || person === void 0 ? void 0 : person.familyRole]);
    var isAdult = useMemo(function () {
        var birthDate = person === null || person === void 0 ? void 0 : person.birthDate;
        if (!birthDate) {
            return;
        }
        var difference = today.diff(birthDate, 'month');
        return difference / MONTHS_FOR_YEAR >= ADULT_AGE;
    }, [person === null || person === void 0 ? void 0 : person.birthDate, today]);
    var isNotSelfProfile = (customer === null || customer === void 0 ? void 0 : customer.personId) !== personId;
    var isMemberDeletable = useMemo(function () { return (person === null || person === void 0 ? void 0 : person.familyRole) !== FamilyRole.FAMILY_LEADER && isNotSelfProfile; }, [isNotSelfProfile, person === null || person === void 0 ? void 0 : person.familyRole]);
    var onTriggerDeleteMemberModal = useCallback(function () { return setIsVisibleModalDeleteMember(function (curr) { return !curr; }); }, []);
    return {
        nameProfile: person === null || person === void 0 ? void 0 : person.name,
        emailProfile: (_a = person === null || person === void 0 ? void 0 : person.Customer) === null || _a === void 0 ? void 0 : _a.email,
        idProfile: person === null || person === void 0 ? void 0 : person.id,
        profileImageUrl: person === null || person === void 0 ? void 0 : person.profileImageUrl,
        dataPerson: dataPerson,
        person: person,
        onPressDeleted: onPressDeleted,
        onPressItemDetail: onPressItemDetail,
        onPressEditPhoto: onPressEditPhoto,
        codeValue: codeValue,
        codeMessage: codeMessage,
        isFamilyMember: isFamilyMember,
        onImageFileChange: onImageFileChange,
        isDeleteLoading: isDeleteLoading,
        isUploadLoading: isUploadLoading,
        isAdult: isAdult,
        isMemberDeletable: isMemberDeletable,
        isNotSelfProfile: isNotSelfProfile,
        isVisibleModalDeleteMember: isVisibleModalDeleteMember,
        onTriggerDeleteMemberModal: onTriggerDeleteMemberModal,
    };
};
